import React, { useState } from 'react';
import './sketches.css';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { sketchData } from '../../Data/sketchData';

const Sketches = ({showAllSketch}) => {
    const sketchDisplay = showAllSketch ? sketchData : sketchData.slice(0,4);
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    const images = sketchDisplay.map(item => item.img);

    const handleCardClick = index => {
        setPhotoIndex(index);
        setIsOpen(true);
    };

    return (
        <div className='sketches slide-in-top-animation'>
            <div className="sketch-desc">
                <h3>Filling my spare moments with delightful sketches, each stroke a gentle whisper of creativity onto the page.</h3>
            </div>
            <div className="sketches-container">
                {sketchDisplay.map(({ img }, index) => (
                    <div className="sketch-card" key={index} onClick={() => handleCardClick(index)}>
                        <div className="img-container" >
                            <img src={img} alt={`img-${index}`} />
                        </div>
                    </div>
                ))}
            {isOpen && (
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                />
            )}
            </div>
        </div>
    );
};

export default Sketches;
